module.exports = __webpack_public_path__ + "img/quizz.f8e4726f.jpg";